import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {DjangoPage} from '../../django-paginator';

@Injectable({providedIn: 'root'})
export class ProductService {
  private apiEndpoint = '/rest-api/v1/shop/products-by-ids';

  constructor(private http: HttpClient) {}

  get(ids) {
    const queryParam = '?ids=' + ids.join();
    return this.http.get(this.apiEndpoint + queryParam);
  }

  getStats = productId => this.http.get(`/rest-api/v1/shop/products/${productId}/stats`);

  createProduct = body => {
    return this.http.post(`/rest-api/v1/admin/companies/0/shop/products`, body);
  };

  updateProduct = (productId, body) => this.http.put(`/rest-api/v1/admin/companies/0/shop/products/${productId}`, body);

  updateProductPhoto = (productId, body) =>
    this.http.put(`/rest-api/v1/admin/companies/0/shop/products/${productId}/photo`, body);

  publish = (companyId, productId) =>
    this.http.put(`/rest-api/v1/admin/companies/${companyId}/shop/products/${productId}/publish`, {});
  unpublish = (companyId, productId) =>
    this.http.put(`/rest-api/v1/admin/companies/${companyId}/shop/products/${productId}/unpublish`, {});
  delete = (companyId, productId) =>
    this.http.delete(`/rest-api/v1/admin/companies/${companyId}/shop/products/${productId}`);

  getPaymentProviders = () => this.http.get(`/rest-api/v1/admin/ticketing/payment_providers`);

  getProducts = (req: any) => {
    return this.http.get<DjangoPage<any>>(`/rest-api/v1/admin/companies/0/shop/products`, {params: req});
  };

  getProductsById = (id: number) => this.http.get(`/rest-api/v1/admin/companies/0/shop/products/${id}`);

  getCommissions = (productId: number) => {
    return this.http.get(`/rest-api/v1/admin/products/${productId}/commissions`);
  };

  updateCommissions = (productId, body) => {
    return this.http.put(`/rest-api/v1/admin/products/${productId}/commissions`, body);
  };
}
